import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from "../../components/panel/panel.jsx";
import { useDispatch, useSelector } from "react-redux";
import { terceroActions } from "../../store";
import EditItemView from "../../components/common/EditItemView";
import Select from "react-select";
import _ from "lodash";

const DatosTercero = () => {
    const { id } = useParams();
    const tercero = useSelector((state) => state.tercero.items[id]);

    const municipio = useSelector((state) => state.municipio.items) || {};
    const customMunicipio = _(municipio)
        .map((v) => ({ value: v.id, label: v.name }))
        .value();

    const departamento = useSelector((state) => state.departamento.items) || {};
    const customDepartamento = _(departamento)
        .map((v) => ({ value: v.id, label: v.name }))
        .value();

    const actividadEconomica = useSelector((state) => state.actividadEconomica.items) || {};
    const customActividadEconomica = _(actividadEconomica)
        .map((v) => ({ value: v.id, label: v.name }))
        .value();

    const [municipioSelected, setMunicipioSelected] = useState(null);
    const [departamentoSelected, setDepartamentoSelected] = useState(null);
    const [actividadEconomicaSelected, setActividadEconomicaSelected] = useState(null);

    const [item, setItem] = useState({ ...tercero });

    useEffect(() => {
        setMunicipioSelected(
            tercero?.municipioId && municipio ? { value: tercero.municipioId, label: municipio[tercero.municipioId]?.name } : null
        );

        setDepartamentoSelected(
            tercero?.departamentoId && departamento
                ? { value: tercero.departamentoId, label: departamento[tercero.departamentoId]?.name }
                : null
        );

        setActividadEconomicaSelected(
            tercero?.actividadEconomicaId && actividadEconomica
                ? { value: tercero.actividadEconomicaId, label: actividadEconomica[tercero.actividadEconomicaId]?.name }
                : null
        );

        setItem({ ...tercero });
    }, [tercero, departamento, actividadEconomica, municipio]);

    const dispatch = useDispatch();

    const handleSelectChangeNV = (name, value) => setItem({ ...item, [name]: value });
    const handleInputChange = (e) => setItem({ ...item, [e.target.name]: e.target.value });
    const handleCheckboxChange = (e) => setItem({ ...item, [e.target.name]: !item[e.target.name] });

    const validate = () => item && item.razonsocial && (item.is_cliente || item.is_proveedor);
    const onItemSaved = (result) => {
        dispatch(terceroActions.update([result]));
    };

    return (
        <div>
            <ol className="breadcrumb float-xl-end">
                <li className="breadcrumb-item">
                    <Link to="/terceros">Terceros</Link>
                </li>
                <li className="breadcrumb-item active">Dato de cliente</li>
            </ol>
            <h1 className="page-header">Datos de tercero</h1>

            <div className="row mb-3">
                <div className="col-xl-12">
                    <Panel>
                        <PanelHeader>Tercero: {tercero?.razonsocial || " Nuevo registro"}</PanelHeader>

                        <EditItemView
                            endpoint="tercero"
                            item={item}
                            setItem={setItem}
                            defaultItem={{}}
                            validate={validate}
                            onItemSaved={onItemSaved}>
                            <PanelBody>
                                <div className="row mb-md-4">
                                    <div className="col-md-6">
                                        <div className="form-floating mb-3 mb-md-0">
                                            <input
                                                type="text"
                                                className="form-control fs-15px"
                                                placeholder="Empresa, S.A. de C.V."
                                                onChange={handleInputChange}
                                                name="razonsocial"
                                                value={item.razonsocial || ""}
                                            />
                                            <label className="d-flex align-items-center fs-13px">NOMBRE O RAZON SOCIAL</label>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <form className="form-floating mb-3 mb-md-0">
                                            <input
                                                type="text"
                                                className="form-control fs-15px"
                                                placeholder="132123-1"
                                                onChange={handleInputChange}
                                                name="registro"
                                                value={item.registro || ""}
                                            />
                                            <label className="d-flex align-items-center fs-13px">NUMERO DE REGISTRO</label>
                                        </form>
                                    </div>

                                    <div className="col-md-3">
                                        <form className="form-floating mb-3 mb-md-0">
                                            <input
                                                type="text"
                                                className="form-control fs-15px"
                                                placeholder="123-123-123"
                                                onChange={handleInputChange}
                                                name="nit"
                                                value={item.nit || ""}
                                            />
                                            <label className="d-flex align-items-center fs-13px">NIT</label>
                                        </form>
                                    </div>
                                </div>

                                <div className="row mb-md-4">
                                    <div className="col-md-6">
                                        <div className="form-floating mb-3 mb-md-0">
                                            <input
                                                type="text"
                                                className="form-control fs-15px"
                                                placeholder="Mi direccion"
                                                onChange={handleInputChange}
                                                name="direccion"
                                                value={item.direccion || ""}
                                            />
                                            <label className="d-flex align-items-center fs-13px">DIRECCION</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <form className="form-floating mb-3 mb-md-0">
                                            <select
                                                className="form-select"
                                                value={item.categoria || ""}
                                                onChange={handleInputChange}
                                                name="categoria">
                                                <option value="PEQUENO">PEQUEÑO</option>
                                                <option value="MEDIANO">MEDIANO</option>
                                                <option value="GRANDE">GRANDE</option>
                                            </select>
                                            <label className="d-flex align-items-center fs-13px">CATEGORIA CONTRIBUYENTE</label>
                                        </form>
                                    </div>

                                    <div className="col-md-3">
                                        <form className="form-floating mb-3 mb-md-0">
                                            <input
                                                type="number"
                                                className="form-control fs-15px"
                                                placeholder="123"
                                                onChange={handleInputChange}
                                                name="diascredito"
                                                value={item.diascredito || ""}
                                            />
                                            <label className="d-flex align-items-center fs-13px">DIAS DE CREDITO</label>
                                        </form>
                                    </div>
                                </div>

                                <div className="row mb-md-4">
                                    <div className="col-md-3">
                                        <form className="mb-3 mb-md-0">
                                            <label className="form-label">MUNICIPIO:</label>
                                            <Select
                                                name="municipioId"
                                                value={municipioSelected}
                                                options={customMunicipio}
                                                isSearchable
                                                placeholder="Seleccione un municipio"
                                                onChange={(v) => {
                                                    setMunicipioSelected(v);
                                                    handleSelectChangeNV("municipioId", v.value);
                                                }}
                                            />
                                        </form>
                                    </div>
                                    <div className="col-md-3">
                                        <form className="mb-3 mb-md-0">
                                            <label className="form-label">DEPARTAMENTO:</label>
                                            <Select
                                                name="departamentoId"
                                                value={departamentoSelected}
                                                options={customDepartamento}
                                                isSearchable
                                                placeholder="Seleccione un departamento"
                                                onChange={(v) => {
                                                    setDepartamentoSelected(v);
                                                    handleSelectChangeNV("departamentoId", v.value);
                                                }}
                                            />
                                        </form>
                                    </div>

                                    <div className="col-md-6">
                                        <form className="mb-3 mb-md-0">
                                            <label className="form-label">ACTIVIDAD ECONOMICA:</label>
                                            <Select
                                                name="actividadEconomicaId"
                                                value={actividadEconomicaSelected}
                                                options={customActividadEconomica}
                                                isSearchable
                                                placeholder="Seleccione una actividad economica"
                                                onChange={(v) => {
                                                    setActividadEconomicaSelected(v);
                                                    handleSelectChangeNV("actividadEconomicaId", v.value);
                                                }}
                                            />
                                        </form>
                                    </div>
                                </div>

                                <div className="row mb-md-4">
                                    <div className="col-md-3">
                                        <form className="form-floating mb-3 mb-md-0">
                                            <input
                                                type="text"
                                                className="form-control fs-15px"
                                                placeholder="132123-1"
                                                onChange={handleInputChange}
                                                name="email"
                                                value={item.email || ""}
                                            />
                                            <label className="d-flex align-items-center fs-13px">EMAIL</label>
                                        </form>
                                    </div>

                                    <div className="col-md-3">
                                        <form className="form-floating mb-3 mb-md-0">
                                            <input
                                                type="text"
                                                className="form-control fs-15px"
                                                placeholder="123-123-123"
                                                onChange={handleInputChange}
                                                name="telefono"
                                                value={item.telefono || ""}
                                            />
                                            <label className="d-flex align-items-center fs-13px">TELEFONO</label>
                                        </form>
                                    </div>
                                </div>

                                <div className="row mb-md-4">
                                    <div className="col-md-6">
                                        <div className="form-floating mb-3 mb-md-0">
                                            <input
                                                type="text"
                                                className="form-control fs-15px"
                                                placeholder="Giro"
                                                onChange={handleInputChange}
                                                name="giro"
                                                value={item.giro || ""}
                                            />
                                            <label className="d-flex align-items-center fs-13px">GIRO</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mb-md-4">
                                    <label className="form-label col-form-label col-md-2">REGISTRAR TERCERO COMO: </label>
                                    <div className="col-md-4">
                                        <div className="form-check mt-2 mb-2">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={handleCheckboxChange}
                                                name="is_cliente"
                                                checked={item.is_cliente || false}
                                            />
                                            <label className="form-check-label">CLIENTE</label>
                                        </div>
                                        <div className="form-check mb-2">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={handleCheckboxChange}
                                                name="is_proveedor"
                                                checked={item.is_proveedor || false}
                                            />
                                            <label className="form-check-label" htmlFor="flexCheckChecked">
                                                PROVEEDOR
                                            </label>
                                        </div>
                                    </div>

                                    <label className="form-label col-form-label col-md-2">APLICAR RETENCION DE IVA: </label>
                                    <div className="col-md-4">
                                        <div className="form-check mt-2 mb-2">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={handleCheckboxChange}
                                                name="is_retencion"
                                                checked={item.is_retencion || false}
                                            />
                                            <label className="form-check-label">
                                                RETENCION 1% <small>(ventas sujetas mayores a $100)</small>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </PanelBody>
                        </EditItemView>
                    </Panel>
                </div>
            </div>
        </div>
    );
};

export default DatosTercero;
